import lodash from 'lodash'
import { fromJS } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import {
  UPDATE_PIN_IN_LIST,
  UPDATE_PINS_BATCH,
  UPDATE_PINS_BATCH_DONE
} from '../PlanViewerNew/constants'
import * as actionTypes from './constants'
import { sortPins } from '../../utils/sortManager'

const initialState = fromJS({
  sort: 'Title', // [Created, Title, Category, Plan, State]
  sortDirection: 'DESC', // [ASC, DESC]
  search: '',
  quickFilter: 'Any', // [Any, ByMe, ByOthers]
  stateFilter: 'Active', // [Active, Inactive, All]
  page: 0,
  maxPage: 0,
  totalElements: 0,
  size: 25
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_GROUP:
      return state
        .set('gettingGroup', false)
        .delete('getGroupError')
        .delete('group')
        .set('page', 0)
        .set('maxPage', 0)
        .set('totalElements', 0)
        .set('size', 25)
        .set('search', '')
        .set('sort', 'Title')
        .set('sortDirection', 'DESC')
        .set('quickFilter', 'Any')
        .set('stateFilter', 'Active')
    case actionTypes.CLEAR_GROUP_CONTENT:
      return state
        .set('gettingGroupContent', false)
        .delete('getGroupContentError')
        .delete('groupContent')

    case actionTypes.GET_GROUP:
      return state.set('gettingGroup', true).delete('getGroupError')
    case actionTypes.GET_GROUP_DONE:
      return state.set('group', action.group).set('gettingGroup', false)
    case actionTypes.GET_GROUP_ERROR:
      return state.set('getGroupError', action.error).set('gettingGroup', false)

    case actionTypes.GET_GROUP_CONTENT:
      return state
        .set('gettingGroupContent', true)
        .delete('getGroupContentError')
    case actionTypes.GET_GROUP_CONTENT_DONE:
      return state
        .setIn(['groupContent', action.page], fromJS(action.content))
        .set('gettingGroupContent', false)
    case actionTypes.GET_GROUP_CONTENT_ERROR:
      return state
        .set('getGroupContentError', action.error)
        .set('gettingGroupContent', false)

    case actionTypes.UPDATE_PINS_BATCH:
    case UPDATE_PINS_BATCH:
      return state.set('updatingPinsBatch', true)
    case UPDATE_PINS_BATCH_DONE:
    case actionTypes.UPDATE_PINS_BATCH_DONE: {
      if (state.get('groupContent')) {
        const page = state.get('page')
        const groupContent = state.get('groupContent').get(page)
        let content

        // Remove the entry from the groupContent list if we are updating from Active(Open, Closed) to Inactive or vice versa
        // else update the item in the groupContent
        if (
          ((action.pins[0].state === 'Open' || 'Closed') &&
            state.get('stateFilter') === 'Inactive') ||
          (action.pins[0].state === 'Inactive' &&
            state.get('stateFilter') === 'Active')
        ) {
          content = groupContent
            .get('content')
            .filter(
              (groupPin) =>
                !lodash.find(action.pins, ['id', groupPin.get('id')])
            )
        } else {
          content = groupContent.get('content').map((groupPin) => {
            const updatedPin = lodash.find(action.pins, [
              'id',
              groupPin.get('id')
            ])
            if (updatedPin) {
              return groupPin.merge(updatedPin)
            }
            return groupPin
          })
        }

        return state
          .set('updatingPinsBatch', false)
          .setIn(['groupContent', page], groupContent.set('content', content))
      }
      return state
    }
    case actionTypes.UPDATE_PINS_BATCH_ERROR:
      return state
        .set('updatePinsBatchError', action.error)
        .set('updatingPinsBatch', false)

    case actionTypes.REMOVE_PINS:
      return state.set('removingPinsBatch', true)
    case actionTypes.REMOVE_PINS_DONE: {
      const page = state.get('page')
      const groupContent = state.get('groupContent').get(page)
      const content = groupContent
        .get('content')
        .filter((groupPin) => action.pins.indexOf(groupPin.get('id')) < 0)
      return state
        .set('removingPinsBatch', false)
        .setIn(['groupContent', page], groupContent.set('content', content))
    }
    case actionTypes.REMOVE_PINS_ERROR:
      return state
        .set('removePinsBatchError', action.error)
        .set('removingPinsBatch', false)

    case actionTypes.UPDATE_GROUP:
      return state.set('updatingGroup', true)
    case actionTypes.UPDATE_GROUP_DONE:
      return state.set('updatingGroup', false)
    case actionTypes.UPDATE_GROUP_ERROR:
      return state
        .set('updateGroupError', action.error)
        .set('updatingGroup', false)

    case actionTypes.DUPLICATE_GROUP:
      return state
        .set('duplicatingGroup', true)
        .delete('newDuplicatedGroup')
        .delete('duplicateGroupError')
    case actionTypes.DUPLICATE_GROUP_DONE:
      return state
        .set('duplicatingGroup', false)
        .set('newDuplicatedGroupId', action.groupId)
    case actionTypes.DUPLICATE_GROUP_ERROR:
      return state
        .set('duplicateGroupError', action.error)
        .set('duplicatingGroup', false)

    // add pins to group
    case actionTypes.ADD_PINS_TO_GROUP:
      return state.set('addingPinsToGroup', true).delete('addPinsToGroupError')
    case actionTypes.ADD_PINS_TO_GROUP_DONE:
      return state.set('addingPinsToGroup', false)
    case actionTypes.ADD_PINS_TO_GROUP_ERROR:
      return state
        .set('addPinsToGroupError', action.error)
        .set('addingPinsToGroup', false)

    case actionTypes.SORT_PINS:
      return state
        .set('sort', action.sort || state.get('sort'))
        .set('sortDirection', action.sortDirection)
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_SEARCH:
      return state.set('search', action.search).set('page', 0).set('maxPage', 0)
    case actionTypes.CHANGE_QUICK_FILTER:
      return state
        .set('quickFilter', action.quickFilter)
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_STATE_FILTER:
      return state
        .set('stateFilter', action.stateFilter)
        .set('page', 0)
        .set('maxPage', 0)
    case actionTypes.CHANGE_PAGE:
      return state.set('page', Number(action.page))
    case actionTypes.CHANGE_SIZE:
      return state
        .set('size', Number(action.size))
        .set('page', 0)
        .set('maxPage', 0)

    case UPDATE_PIN_IN_LIST: {
      let newState = state

      if (state.get('groupContent')) {
        // delete old one and insert new one on the rigth sorted place
        const sortProjectPinsFunc = sortPins(
          state.get('sort'),
          state.get('sortDirection')
        )
        let saved = false
        let deleted = false
        let lastPage = 0

        state.get('groupContent').forEach((pageContent, page) => {
          lastPage = page

          const pContent = pageContent

          pageContent.get('content').forEach((p, key) => {
            const pin = fromJS(p)

            let pinIndex = key
            if (!saved && deleted) {
              pinIndex -= 1
            } else if (saved && !deleted) {
              pinIndex += 1
            }

            if (!saved) {
              const updatedPinMap = fromJS(action.pin)
              const pinCompared = sortProjectPinsFunc(updatedPinMap, pin)
              if (pinCompared === -1) {
                if (pin.get('id') !== action.pin.id) {
                  newState = newState.setIn(
                    ['groupContent', page, 'content'],
                    pContent.get('content').insert(pinIndex, updatedPinMap)
                  )
                } else {
                  newState = newState.setIn(
                    ['groupContent', page, 'content', pinIndex],
                    updatedPinMap
                  )
                  deleted = true
                }
                saved = true
              } else if (pinCompared === 0) {
                if (pin.get('id') === action.pin.id) {
                  newState = newState.setIn(
                    ['groupContent', page, 'content', pinIndex],
                    updatedPinMap
                  )
                  deleted = true
                  saved = true
                }
              } else if (pin.get('id') === action.pin.id) {
                newState = newState.deleteIn([
                  'groupContent',
                  page,
                  'content',
                  pinIndex
                ])
                deleted = true
              }
            } else if (!deleted && pin.get('id') === action.pin.id) {
              newState = newState.deleteIn([
                'groupContent',
                page,
                'content',
                pinIndex
              ])
              deleted = true
            }
          })
        })

        if (!saved && newState.get('groupContent').get(lastPage)) {
          newState = newState.setIn(
            ['groupContent', lastPage, 'content'],
            newState
              .getIn(['groupContent', lastPage, 'content'])
              .push(fromJS(action.pin))
          )
        }
      }

      return newState
    }

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
